import React from 'react';
import '../index.css';
import '../pubic/output.css';

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonFab,
  IonFabButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonImg,
  IonActionSheet,
} from '@ionic/react';
import decentixLogo from "../assets/images/splashdecentixlogo.png"; // Adjust the path if needed
import { chevronDownOutline } from 'ionicons/icons';

import { useState, useEffect } from 'react';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);
    checkMobile(); // Check on mount

    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [breakpoint]);

  return isMobile;
}

export default function Hero() {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <section className="SplashMobile hero text-white h-screen flex items-center" style={{ fontFamily: 'Helvetica, sans-serif' }}>

      <IonGrid>
      <IonRow className="p-4" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <img
          src={decentixLogo}
          alt="Decentix Logo"
          style={{ maxWidth: "25%", maxHeight: "25%", objectFit: "contain" }}
        />
        </IonRow>

      <IonRow>
        <div className="text-left justify-left p-4">
          <h1 className="font-bold" style={{fontSize: "50px", objectFit: "contain"}}>Experiences,<br />Unlocked.</h1>
    {/*
          <p className="mt-4 text-lg">Your journey starts here.</p>
          <button className="mt-6 bg-white text-blue-500 px-6 py-2 rounded-lg">Get Started</button>
    */}
        </div>
        </IonRow>
        <IonRow>
          {/*
            empty row for spacing purposes
            it's ugly, i know...
            shut the fuck up.
          */}
          <h1> <br /> <br /> </h1>
          </IonRow>
          <IonRow>
            <h1> <br /> <br /> </h1>
            </IonRow>
            <IonRow>
              <h1> <br /> <br /> </h1>
              </IonRow>
              <IonRow>
                <h1> <br /> <br /> </h1>
                </IonRow>
                <IonRow>
                  <h1> <br /> <br /> </h1>
                  </IonRow>
          <IonRow className="flex justify-center">

          <svg style={{color: "white", alignItems: "center"}} width="10%" height="10%" data-testid="geist-icon" stroke-linejoin="miters" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.74999 1.75V1H7.24999V1.75V12.4393L3.28032 8.46967L2.74999 7.93934L1.68933 9L2.21966 9.53033L7.29288 14.6036C7.68341 14.9941 8.31657 14.9941 8.7071 14.6036L13.7803 9.53033L14.3107 9L13.25 7.93934L12.7197 8.46967L8.74999 12.4393V1.75Z" fill="currentColor"></path></svg>
          {/*
          <IonIcon icon={chevronDownOutline} className="p-10" style={{ fontSize: "100px", alignItems: "center"}} />
          */}
          </IonRow>
          </IonGrid>
      </section>
    );
} else {
  return (
    <section className="Splash hero text-white h-screen flex items-center" style={{ fontFamily: 'Helvetica, sans-serif' }}>
    <IonGrid>
    <IonRow>
    <IonCol>
      <div className="text-left justify-left p-10">
        <h1 className="font-bold" style={{fontSize: "150px", objectFit: "contain"}}>Experiences,<br />Unlocked.</h1>
{/*
        <p className="mt-4 text-lg">Your journey starts here.</p>
        <button className="mt-6 bg-white text-blue-500 px-6 py-2 rounded-lg">Get Started</button>
*/}
      </div>
      </IonCol>

      <IonCol className="p-10" style={{ display: "flex", justifyContent: "right", alignItems: "center" }}>
        <img
          src={decentixLogo}
          alt="Decentix Logo"
          style={{ maxWidth: "50%", maxHeight: "50%", objectFit: "contain" }}
        />
        </IonCol>
        </IonRow>
        <IonRow>
        {/*
          empty row for spacing purposes
          it's ugly, i know...
          shut the fuck up.
        */}
        <h1> <br /> <br /> </h1>
        </IonRow>
        <IonRow className="flex justify-center">

        <svg style={{color: "white", alignItems: "center"}} width="8%" height="8%" data-testid="geist-icon" stroke-linejoin="miters" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.74999 1.75V1H7.24999V1.75V12.4393L3.28032 8.46967L2.74999 7.93934L1.68933 9L2.21966 9.53033L7.29288 14.6036C7.68341 14.9941 8.31657 14.9941 8.7071 14.6036L13.7803 9.53033L14.3107 9L13.25 7.93934L12.7197 8.46967L8.74999 12.4393V1.75Z" fill="currentColor"></path></svg>

        {/*
        <IonIcon icon={chevronDownOutline} className="p-10" style={{ fontSize: "100px", alignItems: "center"}} />
        */}
        </IonRow>
        </IonGrid>
    </section>
    );
  }
}
